var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhysicalhealth({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(-707 -838)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 33,
    cy: 33,
    r: 33,
    transform: "translate(707 838)",
    fill: "#fef8e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_81be04a96b5a65286250e7d75e4399ec",
    "data-name": "81be04a96b5a65286250e7d75e4399ec",
    transform: "translate(714 848.042)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M36.3,5A12.984,12.984,0,0,0,26.013,9.854,12.984,12.984,0,0,0,15.722,5,14.082,14.082,0,0,0,2,18.722C2,24.777,6.048,33.816,25.309,42.58a1.715,1.715,0,0,0,1.406,0c19.262-8.765,23.309-17.8,23.309-23.858A14.082,14.082,0,0,0,36.3,5Z",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_7",
    "data-name": "Union 7",
    d: "M24.011,37.735a1.653,1.653,0,0,1-.416-.054,1.728,1.728,0,0,1-.364-.139C4.036,28.79,0,19.767,0,13.72A14.082,14.082,0,0,1,13.724,0a13.218,13.218,0,0,1,10.29,4.845A13.217,13.217,0,0,1,34.306,0a14.08,14.08,0,0,1,13.72,13.72c0,6.054-4.044,15.091-23.292,23.853l-.009,0h0a1.681,1.681,0,0,1-.708.155ZM13.724,3.429A10.7,10.7,0,0,0,3.429,13.72c0,7.1,7.116,14.148,20.583,20.414C37.482,27.868,44.6,20.82,44.6,13.72A10.706,10.706,0,0,0,34.306,3.429a9.793,9.793,0,0,0-8.731,5.25,1.715,1.715,0,0,1-1.469,1h-.188a1.718,1.718,0,0,1-1.467-1,9.77,9.77,0,0,0-8.66-5.25Z",
    transform: "translate(2 5.001)",
    fill: "#494f54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_8",
    "data-name": "Union 8",
    d: "M12,24.011a5.145,5.145,0,0,1-5.143-5.143V17.153H5.147a5.145,5.145,0,1,1,0-10.291H6.862V5.143a5.145,5.145,0,0,1,10.29,0V6.862h1.716a5.145,5.145,0,0,1,0,10.291H17.152v1.714A5.145,5.145,0,0,1,12,24.011Z",
    transform: "translate(2 18.722)",
    fill: "#247a3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M32.867,16.148h-3.43a1.715,1.715,0,0,0-1.424.772l-1.492,2.213-2.23-6.964a1.766,1.766,0,0,0-3.122-.394l-2.95,4.374h-2.5a1.715,1.715,0,0,0,0,3.43h3.43a1.715,1.715,0,0,0,1.424-.772l1.492-2.213,2.316,6.964a1.715,1.715,0,0,0,1.406,1.149h.223a1.715,1.715,0,0,0,1.424-.772l2.933-4.357h2.5a1.715,1.715,0,1,0,0-3.43Z",
    transform: "translate(8.582 4.289)",
    fill: "#3666f6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysicalhealth);
export default __webpack_public_path__ + "static/media/physicalhealth.3dfe1f8e72e7ff45ca9a8ecdf1eed4e1.svg";
export { ForwardRef as ReactComponent };